export function getApiBaseUrl(): string {
  // Local Vite proxy avoids CORS against the API during development.
  // Preview/prod use VITE_API_BASE_URL (QA has cors origin: '*' when
  // DENO_ENV=development — see jersey-api main.ts).
  if (import.meta.env.DEV) {
    return '/api'
  }

  return import.meta.env.VITE_API_BASE_URL
}

export async function apiRequest(
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> {
  const baseUrl = getApiBaseUrl()
  const url = `${baseUrl}${endpoint}`

  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}
